import * as React from 'react';
import S from './style/styled';
import { Loader } from '../../animations/loader';
export var Button = function Button(_ref) {
  var _ref$appearance = _ref.appearance,
      appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance,
      text = _ref.text,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'button' : _ref$type,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'normal' : _ref$size,
      _ref$leftIconSize = _ref.leftIconSize,
      leftIconSize = _ref$leftIconSize === void 0 ? 'normal' : _ref$leftIconSize,
      _ref$rightIconSize = _ref.rightIconSize,
      rightIconSize = _ref$rightIconSize === void 0 ? 'small' : _ref$rightIconSize,
      onClick = _ref.onClick,
      _ref$leftIcon = _ref.leftIcon,
      leftIcon = _ref$leftIcon === void 0 ? undefined : _ref$leftIcon,
      _ref$rightIcon = _ref.rightIcon,
      rightIcon = _ref$rightIcon === void 0 ? undefined : _ref$rightIcon,
      hasIconOnly = _ref.hasIconOnly,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      isDismiss = _ref.isDismiss,
      isFull = _ref.isFull,
      ref = _ref.ref,
      style = _ref.style,
      extraProps = _ref.extraProps,
      id = _ref.id,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading;
  return React.createElement(S.Button, Object.assign({
    appearance: appearance,
    rightIcon: rightIcon,
    leftIconSize: leftIconSize,
    rightIconSize: rightIconSize,
    style: style,
    ref: ref,
    type: type,
    id: id,
    onClick: !isDisabled && !isLoading ? onClick : undefined,
    isDismiss: isDismiss,
    leftIcon: leftIcon,
    hasIconOnly: hasIconOnly,
    isDisabled: isDisabled,
    isFull: isFull,
    size: size,
    text: text,
    isLoading: isLoading
  }, extraProps), hasIconOnly ? React.createElement(React.Fragment, null, leftIcon || rightIcon) : leftIcon !== undefined ? React.createElement(React.Fragment, null, leftIcon, React.createElement(S.ButtonText, null, text), rightIcon && rightIcon) : React.createElement(React.Fragment, null, React.createElement(S.ButtonText, null, text), rightIcon && rightIcon), isLoading && React.createElement(Loader, {
    color: 'blue'
  }));
};